<template>
  <div class="overflow-y-auto">
    <div class="min-w-[1300px]">
      <button
        class="w-full border-b-[1px] border-b-[#E2E2E2] py-[6px] flex items-center focus:outline-none"
        :class="visible ? null : 'collapsed'"
        :aria-expanded="visible ? 'true' : 'false'"
        aria-controls="collapse-4"
        @click="visible = !visible"
      >
        <collapse-header-checkbox
          v-model="checked"
          :disabled="checkboxDisabled"
          @change="handleCheckboxChange"
          @click.native.stop
        />
        <div class="grid grid-cols-6 grow text-[#333333]">
          <marketplace-platform-cell
            :platform="data.marketplace"
            :order-number="data.marketplace_order_id"
          />
          <general-cell :value="data.create_time ? DAY_MONTH_YEAR(data.create_time) : '-'" />
          <general-cell :value="data.pickup_deadline ? DAY_MONTH_YEAR(data.pickup_deadline) : '-'" />
          <general-cell :value="data.logistic_name" />
          <general-cell :value="data.seller" />
          <div class="p-[12px] flex items-center justify-start gap-[8px]">
            <pill :value="data.is_printed" />
          </div>
        </div>
        <div class="p-[12px] flex items-center justify-start gap-[8px] sticky -right-[1px] bg-white">
          <span
            class="ml-auto inline-block h-0 w-0 border-l-[6px] border-r-[6px] border-t-[8px] border-l-transparent border-r-transparent border-t-[#333333] transition-transform duration-200"
            :class="visible ? 'rotate-0' : '-rotate-90'"
            aria-hidden="true"
          />
        </div>
      </button>
      <b-collapse
        id="collapse-4"
        v-model="visible"
        class="bg-[#F8F8F8]"
      >
        <collapse-card-body
          :id="data.id"
          :packing-materials-fetcher="packingMaterialsFetcher"
          :is-open="visible || defaultVisible"
          :fulfillment-fee="fulfillmentFee"
          :edited-order-data="editedOrderData"
          @on-save-packing="handleSavePacking"
        />
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import MarketplacePlatformCell from './MarketplacePlatformCell.vue'
import Pill from './Pill.vue'
import GeneralCell from './GeneralCell.vue'
import CollapseCardBody from './CollapseCardBody.vue'
import CollapseHeaderCheckbox from './CollapseHeaderCheckbox.vue'

export default {
  name: 'CollapseCard',
  components: {
    MarketplacePlatformCell,
    Pill,
    GeneralCell,
    CollapseCardBody,
    CollapseHeaderCheckbox,
  },
  props: {
    defaultVisible: {
      type: Boolean,
      default: false,
    },
    packingMaterialsFetcher: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    editedOrderData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    checkedValue: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      visible: this.defaultVisible,
      checked: false,
      newFulfillmentFee: 0,
    }
  },
  computed: {
    fulfillmentFee() {
      return this.newFulfillmentFee || this.data.fulfillment_fee
    },
    checkboxDisabled() {
      const { status } = this.$route.query
      if (!status) {
        return false
      }
      return (status !== 'submitted' && status !== 'confirmed')
    },
  },
  watch: {
    checkedValue(value) {
      this.checked = value
    },
  },
  mounted() {
    this.checked = this.checkedValue
  },
  methods: {
    DAY_MONTH_YEAR,
    handleCheckboxChange() {
      this.$emit('on-checked-change', { state: this.checked, orderNumber: this.data.orderNumber })
    },
    setChecked(state) {
      this.checked = state
    },
    handleSavePacking(message) {
      this.newFulfillmentFee = message.data.grand_fulfillment_cost
      this.$emit('on-save-packing', message)
    },
  },
}
</script>
